/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MODERATOR" | "STAFF" | "%future added value";
export type USER_STATUS = "ACTIVE" | "BANNED" | "PREMOD" | "SUSPENDED" | "WARNED" | "%future added value";
export type CommentContainer_viewer = {
    readonly id: string;
    readonly status: {
        readonly current: ReadonlyArray<USER_STATUS>;
    };
    readonly ignoredUsers: ReadonlyArray<{
        readonly id: string;
    }>;
    readonly badges: ReadonlyArray<string> | null;
    readonly role: USER_ROLE;
    readonly scheduledDeletionDate: string | null;
    readonly mediaSettings: {
        readonly unfurlEmbeds: boolean;
    };
    readonly " $fragmentRefs": FragmentRefs<"UsernameWithPopoverContainer_viewer" | "ReactionButtonContainer_viewer" | "ReportFlowContainer_viewer" | "ReportButton_viewer" | "CaretContainer_viewer">;
    readonly " $refType": "CommentContainer_viewer";
};
export type CommentContainer_viewer$data = CommentContainer_viewer;
export type CommentContainer_viewer$key = {
    readonly " $data"?: CommentContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "CommentContainer_viewer",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "UserStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "current",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "ignoredUsers",
                "plural": true,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "badges",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scheduledDeletionDate",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UserMediaSettings",
                "kind": "LinkedField",
                "name": "mediaSettings",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unfurlEmbeds",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UsernameWithPopoverContainer_viewer"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReactionButtonContainer_viewer"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReportFlowContainer_viewer"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReportButton_viewer"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CaretContainer_viewer"
            }
        ],
        "type": "User",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '1f90e770212c77b1b04d22345905d649';
export default node;
